module.exports = __webpack_public_path__ + "static/Vision-345b516bb6d192b79cdd7d3c334b1434.svg";